import { Button, Drawer, Modal, TextOrHTML } from "@simplybusiness/mobius";
import { useEffect, useState } from "react";
import { useTriggerEventTracker } from "../PersistentSummary/helpers/PersistentPaymentSummaryHelper";
import { ctaAction } from "./ctaAction";

const productNameMap = {
  "General liability": "General Liability",
  "Professional liability": "Professional Liability / Errors & Omissions",
  Cyber: "Cyber",
  "Inland marine": "Business Equipment and Small Tools",
  "Business Owners Policy": "Business Owners Policy",
};

interface DialogueModalProps {
  name: string;
  fieldName: string;
  productInfo: string;
  text?: string;
  isDrawer?: boolean;
}

export const DialogueModal = ({
  name,
  fieldName,
  productInfo,
  text = "Learn more",
  isDrawer = false,
}: DialogueModalProps) => {
  const [open, setOpen] = useState(false);
  const [buttonLabel, setButtonLabel] = useState("Add this coverage");
  const [buttonStyle, setButtonStyle] = useState(false);
  const [eventDetails, setEventDetails] = useState<{
    eventName: string | null;
    args: string[];
  }>({ eventName: null, args: [] });

  useTriggerEventTracker(eventDetails.eventName, ...eventDetails.args);

  const handleCtaClick = () => {
    ctaAction(fieldName, setEventDetails);
    setButtonLabel(
      buttonLabel === "Add this coverage"
        ? "Remove this coverage"
        : "Add this coverage",
    );
    setButtonStyle(!buttonStyle);
    setOpen(false);
  };

  const handleDialogueClick = () => {
    setOpen(true);
    if (fieldName) {
      setEventDetails({
        eventName: "coverage_selection_learn_more_modal_opened",
        args: [fieldName.replace(/_coverage$/, "")],
      });
    }
  };

  useEffect(() => {
    const checkboxes = document.querySelectorAll(
      ".s-step-recommendations input[type=checkbox]",
    );

    const toggleLogic = (box: HTMLInputElement) => {
      if (box && box.checked === false) {
        setButtonLabel("Add this coverage");
        setButtonStyle(false);
      } else {
        setButtonLabel("Remove this coverage");
        setButtonStyle(true);
      }
    };

    checkboxes.forEach(box => {
      box.addEventListener("change", () => {
        toggleLogic(box as HTMLInputElement);
      });

      if ((box as HTMLInputElement).name === fieldName) {
        toggleLogic(box as HTMLInputElement);
      }
    });
  }, [buttonLabel, fieldName]);

  return (
    <>
      <Button
        className="mobius-dialogue-modal__styled-button"
        size="sm"
        onClick={() => {
          handleDialogueClick();
        }}
      >
        {text}
      </Button>

      {!isDrawer && (
        <Modal isOpen={open} onClose={() => setOpen(false)} animation="slideUp">
          <Modal.Header>
            {productNameMap[name as keyof typeof productNameMap] || name}
          </Modal.Header>
          <Modal.Content>
            <div className="mobius-dialogue-modal__description mobius-dialogue-modal__description_non_drawer">
              <TextOrHTML text={productInfo} htmlElementType="div" />
            </div>
          </Modal.Content>
        </Modal>
      )}

      {isDrawer && (
        <Drawer
          isOpen={open}
          onClose={() => setOpen(false)}
          direction="right"
          closeLabel="Close"
        >
          <Drawer.Header>
            <div className="mobius-dialogue-modal__header">
              {productNameMap[name as keyof typeof productNameMap] || name}
            </div>
          </Drawer.Header>
          <Drawer.Content>
            <div className="mobius-dialogue-modal__description mobius-dialogue-modal__description_drawer">
              <div className="mobius-dialogue-modal__styled-drawer-content">
                <TextOrHTML text={productInfo} htmlElementType="div" />
              </div>
              <div className="mobius-dialogue-modal__styled-cta-wrapper">
                <Button
                  className={`mobius-dialogue-modal__styled-cta ${buttonStyle ? "--is-ghost" : ""}`}
                  onClick={() => {
                    handleCtaClick();
                  }}
                >
                  {buttonLabel}
                </Button>
              </div>
            </div>
          </Drawer.Content>
        </Drawer>
      )}
    </>
  );
};
